import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {
    frotasStorage, aeronavesRoute, aeronavesModuleName, embarcacoesRoute,
    embarcacoesModuleName, equipamentosRoute, equipamentosModuleName, maquinarioRoute, outrosRoute, maquinarioModuleName,
    veiculosRoute, veiculosModuleName, outrosModuleName
} from "./data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import set = Reflect.set;

@Injectable()
export class FrotasService {

    constructor(
        private _router: Router,
        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(frotasStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(frotasStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(frotasStorage + "-new");
    }

    setBackStorage(frotaObject: any) {
        let object: string = JSON.stringify(frotaObject);
        sessionStorage.setItem(frotasStorage + '-back', object);
    }

    getBackStorage() {
        let item: string = sessionStorage.getItem(frotasStorage + "-back");
        return JSON.parse(item);
    }

    clearBackStorage() {
        sessionStorage.removeItem(frotasStorage + "-back");
    }

    getModuleName() {
        let url = this._router.url;
        var module: any = {};

        if (url.indexOf(aeronavesRoute) !== -1) {
            module = aeronavesModuleName;
        } else if (url.indexOf(embarcacoesRoute) !== -1) {
            module = embarcacoesModuleName;
        } else if (url.indexOf(equipamentosRoute) !== -1) {
            module = equipamentosModuleName;
        } else if (url.indexOf(maquinarioRoute) !== -1) {
            module = maquinarioModuleName;
        } else if (url.indexOf(outrosRoute) !== -1) {
            module = outrosModuleName;
        } else if (url.indexOf(veiculosRoute) !== -1) {
            module = veiculosModuleName;
        }

        return module;
    }

    getRouteName() {
        let url = this._router.url;
        var routeName: string;

        if (url.indexOf(aeronavesRoute) !== -1) {
            routeName = aeronavesRoute;
        } else if (url.indexOf(embarcacoesRoute) !== -1) {
            routeName = embarcacoesRoute;
        } else if (url.indexOf(equipamentosRoute) !== -1) {
            routeName = equipamentosRoute;
        } else if (url.indexOf(maquinarioRoute) !== -1) {
            routeName = maquinarioRoute;
        } else if (url.indexOf(outrosRoute) !== -1) {
            routeName = outrosRoute;
        } else if (url.indexOf(veiculosRoute) !== -1) {
            routeName = veiculosRoute;
        }

        return routeName;
    }

    getModuleId() {
        let url = this._router.url;
        var moduleId: number;

        if (url.indexOf(aeronavesRoute) !== -1) {
            moduleId = 1;
        } else if (url.indexOf(embarcacoesRoute) !== -1) {
            moduleId = 2;
        } else if (url.indexOf(equipamentosRoute) !== -1) {
            moduleId = 5;
        } else if (url.indexOf(maquinarioRoute) !== -1) {
            moduleId = 4;
        } else if (url.indexOf(outrosRoute) !== -1) {
            moduleId = 99;
        } else if (url.indexOf(veiculosRoute) !== -1) {
            moduleId = 3;
        }

        return moduleId;
    }

    getTipoVeiculo() {
        return 3;
    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    var placa: string = '';
                    if (state.placa) {
                        placa = state.placa.toUpperCase();
                        placa = placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
                        placa = placa + " / ";
                    }

                    text = placa.concat(state.identificacao);
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));

    testBackHistory(autoCompleteId?: string) {
        const history = this.getBackStorage();
        let settings: any = {
            frotaDetailHistory: history,
            frotasModule: this.getModuleName(),
            frotaRoute: this.getRouteName()
        };

        if (settings.frotaRoute) {
            if (autoCompleteId) {
                this.setAutocompleteOption(autoCompleteId, history);
            }
            settings.showFrotaLink = true;
        } else {
            this.clearBackStorage();
            settings.showFrotaLink = false;
        }

        return settings;
    }

    setAutocompleteOption(autoCompleteId: string, frotaObject: any) {
        let placa: string = '';
        if (frotaObject.placa) {
            placa = frotaObject.placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
            placa = placa + ' / ';
        }

        let selectObject: any = {text: placa.concat(frotaObject.identificacao), id: frotaObject.id};

        this._autocompleteService.createOptionOnSelect2(autoCompleteId, selectObject);
        this._autocompleteService.setValueOnSelect2(selectObject.id, autoCompleteId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/shared/frota.service.ts
 **/